import { CreateProvisionEvent, EditProvisionEvent, ProvisionEquipmentSensorListItem, ProvisionEvent, ProvisionEventEquipment } from "features/provisioning/provisions/models/provision-models"
import { deleteRequest, getRequest, postRequest, putRequest, RequestDataType } from "../../../../services/api"

export const getAllProvisionEvents = async () => {
    return ((await getRequest("/provisionEvents")) || []) as ProvisionEvent[]
}

export const getProvisionEventsForAsset = async (assetId: string): Promise<ProvisionEventEquipment[]> => {
    return ((await getRequest(`/provisionEvents/${assetId}`)) || []) as ProvisionEventEquipment[]
}

export const getProvisionSensorsForAsset = async (assetId: string): Promise<ProvisionEquipmentSensorListItem[]> => {
    return ((await getRequest(`/provisionEvents/assets/${assetId}/sensors`)) || []) as ProvisionEquipmentSensorListItem[]
}

export const deleteProvisionEvent = async (provisionEventId: string) => {
    return await deleteRequest("/provisionEvents", provisionEventId)
}

export const editProvisionEvent = async (data: EditProvisionEvent) => {
    return await putRequest("/provisionEvents", data, RequestDataType.Entity)
}


export const postNewProvisionEvent = async (
    data: CreateProvisionEvent,
): Promise<{ statusCode: number; provisionEventDetail: ProvisionEventEquipment }> => {
    const response = await postRequest("/provisionEvents", data, RequestDataType.Entity)
    return {
        statusCode: response.statusCode,
        provisionEventDetail: response.result as ProvisionEventEquipment,
    }
}
